import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PhoneNumberRequest, PhoneNumberResponse } from '../models/phone-number.model';

@Injectable({ providedIn: 'root' })
export class PhoneNumberApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/calls/phone-numbers`;

  listPhoneNumbers(): Observable<PhoneNumberResponse[]> {
    return this.http.get<PhoneNumberResponse[]>(this.base);
  }

  getPhoneNumberById(id: number): Observable<PhoneNumberResponse> {
    return this.http.get<PhoneNumberResponse>(`${this.base}/${id}`);
  }

  createPhoneNumber(req: PhoneNumberRequest): Observable<PhoneNumberResponse> {
    return this.http.post<PhoneNumberResponse>(this.base, req);
  }

  updatePhoneNumber(id: number, req: PhoneNumberRequest): Observable<PhoneNumberResponse> {
    return this.http.put<PhoneNumberResponse>(`${this.base}/${id}`, req);
  }

  deletePhoneNumber(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  setDefaultPhoneNumber(id: number): Observable<PhoneNumberResponse> {
    return this.http.patch<PhoneNumberResponse>(`${this.base}/${id}/default`, {});
  }
}
